export default "__VITE_ASSET__DenldN7z__"